import { t } from 'i18next'
import React from 'react'

import urls from './urls'

export const ENV = 'dev' // prod: product mode, dev: develop mode

export const VAPID_KEY =
  'BN3prUSIHGYz2YgMZcih-VNPHwDH15KJTewmDj6Oh7ymYts8mLhP62AtBq4eeZ7JoOc0of6pZLKJxbczT09LAi4'

export const TOP_NAV_HEIGHT = '72px'

export const config = {
  TAB_RECENT_CALLS: 0,
  TAB_VOICEMAIL: 1,
  TAB_CHAT: 2,
  TAB_FAX: 3,
  TAB_ANALYTICS: 4,
  TAB_EMBEDDED_PHONE: 5,
  TAB_SETTINGS: 6,

  WEBSOCKET_WATCH_TIME: 30000, // 30 seconds

  NUM_SESSIONS_BETWEEN_FEEDBACK: 30,
  MIN_DAYS_BETWEEN_FEEDBACK: 30,
  SESSION_TIMEOUT_MINUTES: 30,
}

export const googleAnalytics = {
  PRODUCTION: 'G-V5F7PN5DJM',
}

export const times = {
  secsOfMin: 60,
  minsOfHour: 60,
  minsOfDay: 1440,
  minsOfWeek: 10080,
  daysOfWeek: 7,
  dayInMilliseconds: 86400000,
}

export const CALL_STATE = () => [
  {
    icon: 'icon-toBottomLeft-arrow-dark900.svg',
    name: t('callState.inboundAnswered'),
  },
  {
    icon: 'icon-toTopRight-arrow-dark900.svg',
    name: t('callState.outboundAnswered'),
  },
  {
    icon: 'icon-toBottomLeft-arrow-red.svg',
    name: t('callState.inboundMissedOrDeclined'),
  },
  {
    icon: 'icon-toTopRight-arrow-red.svg',
    name: t('callState.outboundMissedOrDeclined'),
  },
]

export const VOICEMAIL_STATE = () => [
  {
    icon: 'icon-left-voicemail-received-VM.svg',
    name: t('voicemailState.received'),
  },
  { icon: 'icon-left-voicemail-sent-VM.svg', name: t('voicemailState.sent') },
]

export const CallFilters = {
  RECENT: 0,
  MISSED: 1,
}

export const VoicemailOptions = () => [
  { label: t('voicemailOptions.recent'), value: 'unknown', default: true },
  { label: t('voicemailOptions.unread'), value: 'true' },
]

export const VoicemailFilters = {
  ALL: 0,
  UNREAD: 1,
}

export const PhoneOptions = () => [
  { label: t('phoneOptions.recent'), value: 0, default: true },
  { label: t('phoneOptions.missed'), value: 1 },
]

export const FaxFilters = {
  ALL: 0,
  SENT: 1,
  RECEIVED: 2,
}

export const ChatOptions = () => [
  { label: t('chatOptions.recent'), value: 0, default: true },
  { label: t('chatOptions.unread'), value: 1 },
]

export const SnippetOptions = () => [
  { label: t('snippetOptions.pbx'), value: 'pbx', default: true },
  { label: t('snippetOptions.personal'), value: 'personal' },
]

export const ChatFilters = {
  RECENT: 0,
  UNREAD: 1,
}

export const ThreadTypes = {
  DIRECT_MESSAGE_THREAD: 1,
  PRIVATE_TEXT_THREAD: 2,
  GROUP_INTERNAL_THREAD: 3,
  GROUP_TEXT_THREAD: 4,
}

export const SocketStatus = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
  ERRORED: 4,
}

export const GeneralMenu = () => [
  {
    id: 0,
    label: t('generalMenu.label'),
    icon: 'icon-thoughtCloud-feedback-dark900.svg',
  },
]

export const ChatMenu = () => [
  { id: 1, label: t('chatMenu.label'), icon: 'icon-texting-dark900.svg' },
]

export const PhoneMenu = () => [
  { id: 0, label: t('phoneMenu.label'), icon: 'icon-lightning-autoAnswer.svg' },
]

export const ExperimentsMenu = () => [
  { label: t('experimentsMenu.label'), icon: 'WebPhone-32x32-Black.svg' },
]

export const DevelopMenu = () => [
  {
    id: 0,
    label: t('developMenu.notifications'),
    icon: 'icon-notification-bell.svg',
  },
  { id: 1, label: t('developMenu.contacts'), icon: 'icon-person-blue.png' },
]

export const THEMES = [
  { value: 0, label: 'Original Blue', color: '#0197F6' },
  { value: 1, label: 'Dark Blue', color: '#446DF6' },
  { value: 2, label: 'Salmon Pink', color: '#FF9999' },
  { value: 3, label: 'Middle Purple', color: '#DB89B0' },
  { value: 4, label: 'Light Blue', color: '#AFCBFF' },
]

export const HEXColorReg = [
  /^#[0-9A-F]$/i,
  /^#[0-9A-F]{2}$/i,
  /^#[0-9A-F]{3}$/i,
  /^#[0-9A-F]{4}$/i,
  /^#[0-9A-F]{5}$/i,
  /^#[0-9A-F]{6}$/i,
]

export const FILESIZE = {
  MAX_FAX: 25 * 1024 * 1024,
  MAX_MMS: 1024 * 1024,
  BytesOfMega: 1024 * 1024,
  BytesOfKilo: 1024,
}

export const FaxFileTypes = {
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/bmp': ['.bmp'],
  'image/tiff': ['.tiff'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'text/rtf': ['.rtf'],
  'text/plain': ['.txt'],
  'application/rtf': ['.rtf'],
  'text/csv': ['.csv'],
}

export const MMSTypes = {
  'audio/3gpp': ['.3gp'],
  'audio/amr': ['.amr'],
  'audio/mp4': ['.mp4'],
  'audio/mp3': ['.mp3'],
  'audio/mpeg': ['.mp3'],
  'audio/wav': ['.wav'],
  'image/png': ['.png'],
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'video/3gpp': ['.3gp'],
  'video/mp4': ['.mp4'],
}

export const ImageTypes = ['image/bmp', 'image/gif', 'image/jpeg', 'image/png']

export const PlayerControlScale = 10

export const INITIALS = { count: 1, next: null, previous: null, results: [] }

export const ModalOrder = { top: 9999, middle: 99, low: 10 }

export const MangoPhoneTypes = () => [
  { value: 'mobile', label: t('mangoPhoneTypes.mobile') },
  { value: 'work', label: t('mangoPhoneTypes.work') },
  { value: 'home', label: t('mangoPhoneTypes.home') },
]

export const MangoContactTypes = () => [
  { id: 1, value: 'mango', label: t('mangoContactTypes.mango') },
]

export const MAX_CHARACTER_COUNT = 1000

export const dropZoneMappings = new Map([
  [
    'file-too-large',
    (source) => ({
      title: t('dropZoneMappings.fileToLarge.title'),
      description: t('dropZoneMappings.fileToLarge.description', {
        maxFileSize: source === 'fax' ? '25' : '1',
      }),
    }),
  ],
  [
    'file-invalid-type',
    (source) => {
      const link = (
        <a href={urls.FAX_SUPPORT} target="_blank" rel="noreferrer">
          {t('dropZoneMappings.fileInvalidType.link')}
        </a>
      )
      return {
        title: t('dropZoneMappings.fileInvalidType.title'),
        description:
          source === 'fax' ? (
            <>
              {t('dropZoneMappings.fileInvalidType.faxDescription', { link })}
            </>
          ) : (
            t('dropZoneMappings.fileInvalidType.description', {
              urlLink: urls.MMS_SUPPORT,
            })
          ),
      }
    },
  ],
  [
    'general',
    () => ({
      title: t('dropZoneMappings.general.title'),
      description: t('dropZoneMappings.general.description'),
    }),
  ],
])

export const getDropZoneMapping = (code, args) => {
  return dropZoneMappings.get(code)(args) || dropZoneMappings.get('general')()
}

export const QUICK_ACTIONS = {
  call: 'call',
  edit: 'edit',
  settings: 'settings',
  fax: 'fax',
  text: 'text',
}

export const quickActionsMap = new Map([
  [
    config.TAB_CHAT,
    {
      quickActions: [
        QUICK_ACTIONS.call,
        QUICK_ACTIONS.edit,
        QUICK_ACTIONS.settings,
      ],
    },
  ],
  [
    config.TAB_RECENT_CALLS,
    {
      quickActions: [QUICK_ACTIONS.call, QUICK_ACTIONS.text],
    },
  ],
  [
    config.TAB_VOICEMAIL,
    { quickActions: [QUICK_ACTIONS.text, QUICK_ACTIONS.call] },
  ],
  [config.TAB_FAX, { quickActions: [QUICK_ACTIONS.fax, QUICK_ACTIONS.text] }],
])
